<template>   
  <b-card-text class="sales-settings-configuration">
    <b-tabs class="sales-settings-tabs" content-class="mt-3" nav-class="sales-settings-tabs__nav">
      <b-tab active>
        <template v-slot:title>
          <b-icon icon="gear-fill" class="sales-settings-tabs__icon"></b-icon>
          Configuración general
        </template>
    <b-row class="sales-settings-configuration__groups">
      <b-col md="6">
        <b-row>
          <b-col md="10" v-if="crud.form.ID1">
            <b-form-group label="Cantidad por defecto al agregar producto">
              <b-form-input type="number"
                            step="1"
                            size="sm"
                            v-model="crud.form.ID1.value_number"
                            placeholder="Cantidad por defecto">
              </b-form-input>
            </b-form-group>
          </b-col>     
        </b-row>
        <b-row class="mt-3">
          <b-col md="10" v-if="crud.form.ID2">        
            <FindObject render="search"
                        type="customers" 
                        tag="Cliente por defecto en nuevo comprobante"
                        @select-object="loadCustomers($event)" 
                        :valueID="crud.form.ID2.value_number"
                        :key="crud.form.ID2.value_number"
                        :where="conditionCustomersActive"/>                                   
          </b-col>
        </b-row>
        <b-row class="mt-3" v-if="showRemits">
          <b-col md="10" sm="12" v-if="crud.form.ID3">   
            <b-form-group label="Remito por defecto al realizar un comprobante de venta" 
                          description="Esta opción predetermina el checkbox para la generación del remito, puede cambiar la configuración en el mismo proceso de venta">       
              <b-form-select v-model="crud.form.ID3.value_string" :options="crud.form.ID3.value_string_opt"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="10" v-if="crud.form.ID14">
            <b-form-group label="Días previos para filtro en consultas de ventas" description="El valor cargado representa a la resta de hoy menos estos días para inicializar la [fecha desde] en consultas de ventas y recibos">
              <b-form-input type="number"
                            step="1"
                            size="sm"
                            v-model="crud.form.ID14.value_number"
                            placeholder="Días por defecto">
              </b-form-input>
            </b-form-group>
          </b-col>     
        </b-row>              
      </b-col>
      <b-col md="6">
        <b-row>
          <b-col md="12" sm="12">
            <b-form-group label="Límite de Crédito">
                <b-form-checkbox                  
                  v-model="crud.form.ID4.value_boolean"
                  switch
                >
                  Válidar el límite de crédito de clientes en cada venta
                </b-form-checkbox>
                
            </b-form-group>
          </b-col>  
        </b-row>
        <b-row>
          <b-col md="12" sm="12">
            <b-form-group label="Recibo en Venta">
                <b-form-checkbox                  
                  v-model="crud.form.ID5.value_boolean"
                  switch
                >
                  Activar el recibo en la generación de facturas simples
                </b-form-checkbox>
                
            </b-form-group>
          </b-col>  
        </b-row>
        <b-row>
          <b-col md="12" sm="12">
            <b-form-group label="Edición de precios">
                <b-form-checkbox                  
                  v-model="crud.form.ID6.value_boolean"
                  switch
                >
                  Bloquear edición de precio en venta
                </b-form-checkbox>
                
            </b-form-group>
          </b-col>  
        </b-row>        
        <b-row>
          <b-col md="12" sm="12">
            <b-form-group label="Transporte">
                <b-form-checkbox                  
                  v-model="crud.form.ID7.value_boolean"
                  switch
                >
                  Habilitar el transporte en la carga de la venta
                </b-form-checkbox>
                
            </b-form-group>
          </b-col>  
        </b-row>
        <b-row>
          <b-col md="12" sm="12">
            <b-form-group label="Fechas">
                <b-form-checkbox                  
                  v-model="crud.form.ID8.value_boolean"
                  switch
                >
                  Bloquear la edición de las fechas en la generación de comprobantes
                </b-form-checkbox>
                
            </b-form-group>
          </b-col>  
        </b-row>
        <b-row>
          <b-col md="12" sm="12">
            <b-form-group label="Métricas">
                <b-form-checkbox                  
                  v-model="crud.form.ID9.value_boolean"
                  switch
                >
                Permite filtrar por rango horario desde/hasta en las metricas de ventas
                </b-form-checkbox>
                
            </b-form-group>
          </b-col>  
        </b-row>
        <b-row>
          <b-col md="12" sm="12">
            <b-form-group label="Nota de Crédito" description="Permite generación de nota de crédito, siempre y cuando el cliente NO tenga saldo a favor">
                <b-form-checkbox                  
                  v-model="crud.form.ID12.value_boolean"
                  switch
                >
                Validar cuenta corriente del cliente para generar Notas de Crédito
                </b-form-checkbox>
                
            </b-form-group>
          </b-col>  
        </b-row>    
        <b-row>
          <b-col md="12" sm="12">
            <b-form-group label="Devolución de Mercadería" description="Funciona en casos donde se usen los conceptos simulando ser productos">
                <b-form-checkbox                  
                  v-model="crud.form.ID13.value_boolean"
                  switch
                >
                Permite hacer devolución de mercaderia cargadas como conceptos
                </b-form-checkbox>
                
            </b-form-group>
          </b-col>  
        </b-row>                
        <b-row>
          <b-col md="12" sm="12">
            <b-form-group label="Facturación múltiple de Presupuestos" description="Permite seleccionar varios presupuestos ganados de un mismo cliente y facturarlos en una sola factura">
                <b-form-checkbox
                  v-model="crud.form.ID15.value_boolean"
                  switch
                >
                Permite facturar varios presupuestos en una sola factura
                </b-form-checkbox>

            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
      </b-tab>

      <b-tab>
        <template v-slot:title>
          <b-icon icon="cart-fill" class="sales-settings-tabs__icon"></b-icon>
          Venta Mostrador
        </template>
        <b-row>
          <b-col md="6">
            <div v-if="crud.form.ID16">
              <FindObject render="search" type="priceList" tag="Lista de precios para venta mostrador"
                          @select-object="loadSalesCounterPriceList($event)" :valueID="crud.form.ID16.value_number"
                          :key="crud.form.ID16.value_number" :where="conditionPriceListActive"/>
            </div>
            <div class="mt-3" v-if="crud.form.ID17">
              <FindObject render="search" type="erpMethodsPayment" tag="Condición de pago para venta mostrador"
                          @select-object="loadSalesCounterMethodPayment($event)" :valueID="crud.form.ID17.value_number"
                          :key="crud.form.ID17.value_number"/>
            </div>
            <div class="mt-3" v-if="crud.form.ID18">
              <FindObject render="search" type="concepts" tag="Concepto rápido para venta mostrador"
                          @select-object="loadSalesCounterConcept($event)" :valueID="crud.form.ID18.value_number"
                          :key="crud.form.ID18.value_number"/>
            </div>
          </b-col>
          <b-col md="6" v-if="crud.form.ID19">
            <b-form-group label="Etiquetas de balanza"
                          description="Creá una regla a partir de una etiqueta de ejemplo. Los códigos que no coincidan siguen el circuito normal.">
              <b-card v-for="(format, index) in crud.form.ID19.formats" :key="format._key" class="mb-2" body-class="p-2">
                <div class="d-flex align-items-center mb-2" style="gap:8px">
                  <b-form-checkbox v-model="format.enabled" switch>Habilitada</b-form-checkbox>
                  <b-form-input v-model.trim="format.name" size="sm" placeholder="Nombre de la regla" />
                  <b-button variant="outline-danger" size="sm" @click="removeWeighedFormat(index)">Eliminar</b-button>
                </div>
                <template>
                  <b-form-group label="Código de prueba" label-size="sm" class="mb-2">
                    <b-form-input v-model.trim="format.sampleCode" size="sm" inputmode="numeric" placeholder="Escaneá o pegá el código completo de una etiqueta" />
                  </b-form-group>
                  <small class="text-muted d-block mb-1">Separá el código de prueba según lo que ves impreso en la etiqueta.</small>
                  <b-row>
                    <b-col cols="3"><b-form-group label="Prefijo" label-size="sm"><b-form-input v-model.trim="format.prefix" size="sm" inputmode="numeric" @input="generateWeighedRegex(format)" /></b-form-group></b-col>
                    <b-col cols="3"><b-form-group label="Producto" label-size="sm"><b-form-input v-model.trim="format.productSample" size="sm" inputmode="numeric" @input="generateWeighedRegex(format)" /></b-form-group></b-col>
                    <b-col cols="3"><b-form-group label="Importe" label-size="sm"><b-form-input v-model.trim="format.priceSample" size="sm" inputmode="numeric" @input="generateWeighedRegex(format)" /></b-form-group></b-col>
                    <b-col cols="3"><b-form-group label="Final / verif." label-size="sm"><b-form-input v-model.trim="format.suffix" size="sm" inputmode="numeric" @input="generateWeighedRegex(format)" /></b-form-group></b-col>
                  </b-row>
                  <b-row class="mt-1 align-items-center">
                    <b-col cols="12" class="d-flex align-items-center" style="gap:8px">
                      <b-form-input v-model.number="format.priceDecimals" type="number" min="0" max="6" size="sm" placeholder="Decimales del importe" style="max-width:170px" />
                      <small class="text-muted">Cantidad de decimales del importe: <strong>0</strong> = 03777 → $3.777 · <strong>2</strong> = 03777 → $37,77.</small>
                    </b-col>
                  </b-row>
                  <small v-if="format.sampleCode" :class="visualFormatStatus(format).valid ? 'text-success' : 'text-warning'" class="d-block mt-2">
                    {{ visualFormatStatus(format).message }}
                  </small>
                  <div v-if="format.regex" class="mt-2">
                    <small class="text-muted">Formato generado</small>
                    <b-form-input :value="format.regex" size="sm" readonly />
                  </div>
                  <b-alert v-if="weighedFormatPreview(format)" show variant="light" class="mt-2 mb-0 py-2 px-3 small">
                    <strong>Ejemplo al leer este código:</strong><br>
                    Producto a buscar: <strong>{{ weighedFormatPreview(format).productCode }}</strong><br>
                    Precio final: <strong>{{ weighedFormatPreview(format).formattedPrice }}</strong>
                  </b-alert>
                </template>
                <small class="text-muted d-block mt-1">El formato se genera automáticamente y se usa sólo cuando el código completo coincide.</small>
              </b-card>
              <b-button variant="outline-primary" size="sm" @click="addWeighedFormat">Agregar formato</b-button>
            </b-form-group>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>

    <b-row class="sales-settings-configuration__footer">
      <b-col md="12" class="text-right">
        <b-button variant="primary" @click="save()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col>
        <hr>
      </b-col>
    </b-row>
    <b-row class="">
      <b-col>
        <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
          <AppIcon name="back" class="mr-1" />
          Volver
        </b-button>                        
      </b-col>      
    </b-row>                       
  </b-card-text>
</template>
<script>
  import serviceAPI from './../services'
  import Error from '@/handler/error'
  import Modules from '@/config/modules'
  import Session from '@/handler/session'  
  import TabBusiness from '@/components/inc/myBusiness/business'
  import FindObject from '@/components/inc/find/findObject'  

  export default {
    components: {        
      TabBusiness,
      FindObject,
    },    
    data: () => {
      return {              
        crud: { 
          form: {
            ID1: {
              id: 0,
              value_string: '',
              value_number: 0,
              value_boolean: false,
            },
            ID2: {
              id: 0,
              value_string: '',
              value_number: 0,
              value_boolean: false,
            },  
            ID3: {
              id: 0,
              value_string: 'default',
              value_string_opt: [
                {value: 'default', text: 'Emite remito segun el origen de la venta'},
                {value: 'always-remit', text: 'Siempre emitir remito'},
                {value: 'never-remit', text: 'Nunca emitir remito'},
              ],
              value_number: 0,
              value_boolean: false,
            },  
            ID4: {
              id: 0,
              value_string: '',
              value_number: 0,
              value_boolean: false,
            }, 
            ID5: {
              id: 0,
              value_string: '',
              value_number: 0,
              value_boolean: false,
            },  
            ID6: {
              id: 0,
              value_string: '',
              value_number: 0,
              value_boolean: false,
            },
            ID7: {
              id: 0,
              value_string: '',
              value_number: 0,
              value_boolean: false,
            }, 
            ID8: {
              id: 0,
              value_string: '',
              value_number: 0,
              value_boolean: false,
            },
            ID9: {
              id: 0,
              value_string: '',
              value_number: 0,
              value_boolean: false,
            }, 
            ID12: {
              id: 0,
              value_string: '',
              value_number: 0,
              value_boolean: false,
            },
            ID13: {
              id: 0,
              value_string: '',
              value_number: 0,
              value_boolean: false,
            },
            ID14: {
              id: 0,
              value_string: '',
              value_number: 0,
              value_boolean: false,
            }, 
            ID15: {
              id: 0,
              value_string: '',
              value_number: 0,
              value_boolean: false,
            },
            ID16: {
              id: 0,
              value_string: '',
              value_number: 0,
              value_boolean: false,
            },
            ID17: {
              id: 0,
              value_string: '',
              value_number: 0,
              value_boolean: false,
            },
            ID18: {
              id: 0,
              value_string: '',
              value_number: 0,
              value_boolean: false,
            },
            ID19: {
              id: 0,
              value_string: '',
              value_number: 0,
              value_boolean: false,
              formats: [],
            },
          },             
        },
        tabIndex: 0,       
        modulesActive: [],        
      }
    },
    mounted () {      
      this.show()      
    },
    computed: {
      // CONDITIONS SELECT
      conditionCustomersActive(){
        return [{field: 'active', condition: true}];
      },          
      conditionPriceListActive(){
        return [{field: 'active', condition: true}];
      },

      showRemits() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules        
        modules.forEach(element => {
          if(element.id == Modules.REMITOS) {                             
            status = true                       
          }
        })        
        return status
      },      

    },
    methods: {
      // SELECT
      loadCustomers (object) {        
        if(object){          
          this.crud.form.ID2.value_number = object.id             
        } else {          
          this.crud.form.ID2.value_number = 0          
        }
      }, 
      loadSalesCounterPriceList (object) {
        if(object){
          this.crud.form.ID16.value_number = object.id
        } else {
          this.crud.form.ID16.value_number = 0
        }
      },
      loadSalesCounterMethodPayment (object) {
        if(object){
          this.crud.form.ID17.value_number = object.id
        } else {
          this.crud.form.ID17.value_number = 0
        }
      },
      loadSalesCounterConcept (object) {
        this.crud.form.ID18.value_number = object ? object.id : 0
      },
      addWeighedFormat() {
        this.crud.form.ID19.formats.push({
          _key: `${Date.now()}_${Math.random()}`,
          name: '',
          enabled: true,
          regex: '',
          productGroup: 1,
          priceGroup: 2,
          priceDecimals: 0,
          sampleCode: '',
          prefix: '',
          productSample: '',
          priceSample: '',
          suffix: '',
        })
      },
      removeWeighedFormat(index) {
        this.crud.form.ID19.formats.splice(index, 1)
      },
      escapeRegex(value) {
        return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      },
      generateWeighedRegex(format) {
        if (!format) return
        const productLength = String(format.productSample || '').length
        const priceLength = String(format.priceSample || '').length
        const suffixLength = String(format.suffix || '').length
        if (!format.prefix || !productLength || !priceLength) {
          format.regex = ''
          return
        }
        const productFirst = String(format.sampleCode || '').indexOf(format.productSample) <=
          String(format.sampleCode || '').indexOf(format.priceSample)
        const suffixPattern = suffixLength ? `\\d{${suffixLength}}` : ''
        const dataPattern = productFirst
          ? `(\\d{${productLength}})(\\d{${priceLength}})`
          : `(\\d{${priceLength}})(\\d{${productLength}})`
        format.regex = `^${this.escapeRegex(format.prefix)}${dataPattern}${suffixPattern}$`
        format.productGroup = productFirst ? 1 : 2
        format.priceGroup = productFirst ? 2 : 1
      },
      visualFormatMatchesSample(format) {
        return this.visualFormatStatus(format).valid
      },
      visualFormatStatus(format) {
        const sample = String(format.sampleCode || '')
        const product = String(format.productSample || '')
        const price = String(format.priceSample || '')
        const prefix = String(format.prefix || '')
        const suffix = String(format.suffix || '')
        const productAt = sample.indexOf(product)
        const priceAt = sample.indexOf(price)
        if (!sample || !product || !price || productAt === -1 || priceAt === -1) {
          return { valid: false, message: 'Ingresá el código de prueba y los bloques exactos de producto e importe.' }
        }
        if (productAt === priceAt || (productAt < priceAt + price.length && priceAt < productAt + product.length)) {
          return { valid: false, message: 'Los bloques de producto e importe se superponen; revisalos.' }
        }
        const middle = productAt < priceAt ? product + price : price + product
        const complete = prefix + middle + suffix
        return complete === sample
          ? { valid: true, message: 'La división coincide con el código de prueba.' }
          : { valid: false, message: 'Los bloques no coinciden con el código de prueba en ese orden.' }
      },
      weighedFormatPreview(format) {
        if (!this.visualFormatStatus(format).valid) return null
        const rawPrice = String(format.priceSample || '')
        const decimals = Math.max(0, Math.min(6, parseInt(format.priceDecimals || 0)))
        const price = Number(rawPrice) / Math.pow(10, decimals)
        if (!Number.isFinite(price)) return null
        const productCode = String(format.productSample || '')
        return {
          productCode,
          rawPrice,
          formattedPrice: Intl.NumberFormat('es-AR', {
            style: 'currency',
            currency: 'ARS',
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
          }).format(price),
        }
      },
      parseWeighedFormats(value) {
        try {
          const formats = JSON.parse(value || '[]')
          return Array.isArray(formats) ? formats.map(format => ({
            _key: `${Date.now()}_${Math.random()}`,
            name: format.name || '',
            enabled: format.enabled !== false,
            regex: format.regex || '',
            productGroup: parseInt(format.productGroup || 1),
            priceGroup: parseInt(format.priceGroup || 2),
            priceDecimals: parseInt(format.priceDecimals || 0),
            sampleCode: format.sampleCode || '',
            prefix: format.prefix || '',
            productSample: format.productSample || '',
            priceSample: format.priceSample || '',
            suffix: format.suffix || '',
          })) : []
        } catch(e) {
          return []
        }
      },
      serializeWeighedFormats() {
        const formats = this.crud.form.ID19.formats.map(format => ({
          name: format.name,
          enabled: format.enabled,
          regex: format.regex,
          productGroup: format.productGroup,
          priceGroup: format.priceGroup,
          priceDecimals: format.priceDecimals,
          sampleCode: format.sampleCode,
          prefix: format.prefix,
          productSample: format.productSample,
          priceSample: format.priceSample,
          suffix: format.suffix,
        }))
        this.crud.form.ID19.value_string = JSON.stringify(formats)
      },
              
      show() {   
        var result = serviceAPI.obtenerConfiguracion()

        result.then((response) => {
          var data = response.data
          
          data.forEach(element => {            
            if(element.id == 1)  {
              this.crud.form.ID1.id = element.id
              this.crud.form.ID1.value_number = parseInt(element.value_number)
            }            
            
            if(element.id == 2)  {
              this.crud.form.ID2.id = element.id
              this.crud.form.ID2.value_number = parseInt(element.value_number)
            }
            
            if(element.id == 3)  {
              this.crud.form.ID3.id = element.id
              this.crud.form.ID3.value_string = element.value_string
            }            

            if(element.id == 4)  {
              this.crud.form.ID4.id = element.id
              this.crud.form.ID4.value_boolean = element.value_boolean
            }                        

            if(element.id == 5)  {
              this.crud.form.ID5.id = element.id
              this.crud.form.ID5.value_boolean = element.value_boolean
            }    

            if(element.id == 6)  {
              this.crud.form.ID6.id = element.id
              this.crud.form.ID6.value_boolean = element.value_boolean
            }  
            
            if(element.id == 7)  {
              this.crud.form.ID7.id = element.id
              this.crud.form.ID7.value_boolean = element.value_boolean
            }    
            
            if(element.id == 8)  {
              this.crud.form.ID8.id = element.id
              this.crud.form.ID8.value_boolean = element.value_boolean
            }                

            if(element.id == 9)  {
              this.crud.form.ID9.id = element.id
              this.crud.form.ID9.value_boolean = element.value_boolean
            }
            
            if(element.id == 12)  {
              this.crud.form.ID12.id = element.id
              this.crud.form.ID12.value_boolean = element.value_boolean
            }    
            
            if(element.id == 13)  {
              this.crud.form.ID13.id = element.id
              this.crud.form.ID13.value_boolean = element.value_boolean
            }        
            
            if(element.id == 14)  {
              this.crud.form.ID14.id = element.id
              this.crud.form.ID14.value_number = parseInt(element.value_number)
            }

            if(element.id == 15)  {
              this.crud.form.ID15.id = element.id
              this.crud.form.ID15.value_boolean = element.value_boolean
            }

            if(element.id == 16)  {
              this.crud.form.ID16.id = element.id
              this.crud.form.ID16.value_number = parseInt(element.value_number)
            }

            if(element.id == 17)  {
              this.crud.form.ID17.id = element.id
              this.crud.form.ID17.value_number = parseInt(element.value_number)
            }

            if(element.id == 18)  {
              this.crud.form.ID18.id = element.id
              this.crud.form.ID18.value_number = parseInt(element.value_number)
            }

            if(element.id == 19)  {
              this.crud.form.ID19.id = element.id
              this.crud.form.ID19.value_string = element.value_string || ''
              this.crud.form.ID19.formats = this.parseWeighedFormats(element.value_string)
            }
          });          
        })
        .catch(error => {              
          this.$awn.alert(Error.showError(error));
        })        
      },              
      save() {           
        this.$bvModal.msgBoxConfirm('¿Guardar configuración?', {
          title: 'Guardar',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'GUARDAR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: "dark",
          headerTextVariant: "white",
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {
          if (value) {                     
            const invalidFormat = this.crud.form.ID19.formats.find(format => !this.visualFormatStatus(format).valid)
            if (invalidFormat) {
              this.$awn.alert('Revisá la división del código de prueba en las etiquetas de balanza antes de guardar.')
              return
            }
            let loader = this.$loading.show();
            this.serializeWeighedFormats()
            
            const configurations = [
              this.crud.form.ID1, this.crud.form.ID2, this.crud.form.ID3,
              this.crud.form.ID4, this.crud.form.ID5, this.crud.form.ID6,
              this.crud.form.ID7, this.crud.form.ID8, this.crud.form.ID9,
              this.crud.form.ID12, this.crud.form.ID13, this.crud.form.ID14,
              this.crud.form.ID15, this.crud.form.ID16, this.crud.form.ID17,
              this.crud.form.ID18, this.crud.form.ID19,
            ]

            Promise.all(configurations.map(configuration => serviceAPI.saveConfiguracion(configuration)))
            .then(() => {
              loader.hide()
              this.show()
              this.$awn.success("Configuración guardada");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error))
            })
          }
        })
        .catch(error => {          
          this.$awn.alert(Error.showError(error));
        })
      },    
    } 
  }
</script>
<style scoped>
  .sales-settings-tabs /deep/ .sales-settings-tabs__nav {
    border-bottom: 1px solid #d8e1eb;
    gap: 8px;
  }

  .sales-settings-tabs /deep/ .nav-link {
    align-items: center;
    border: 1px solid transparent;
    border-radius: 8px 8px 0 0;
    color: #5e7894;
    display: inline-flex;
    font-weight: 600;
    gap: 7px;
    padding: 10px 16px;
  }

  .sales-settings-tabs /deep/ .nav-link:hover {
    background: #f2f7fb;
    border-color: #d8e1eb;
    color: #1769aa;
  }

  .sales-settings-tabs /deep/ .nav-link.active {
    background: #fff;
    border-color: #b8d4ec #b8d4ec #fff;
    color: #0b78b6;
  }

  .sales-settings-tabs__icon {
    font-size: 16px;
  }
</style>
